module.exports = __webpack_public_path__ + "img/blockables-instructions-3.09ec07b6.png";